import React from 'react';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { Box } from 'grid-styled';
import flowRight from 'lodash/flowRight';
import get from 'lodash/get';

import Input from '../form/Input';

import { Header2 } from '../styledSystem/Text';
import { BoxTemplate } from '../styledSystem/Box';
import Button from '../uic/Button';

import LoginModel from '../models/LoginModel';
import Background from '../assets/alert-circle.png';
import session from '../session';

class Login extends React.Component {
    state = {
        username: '',
        password: '',
        formErrors: { username: '', password: '' },
        busy: false
    };

    model = new LoginModel();

    async componentDidMount() {
        const { history, location } = this.props;

        const success = await session.restore();
        if (success) {
            history.replace(get(location, 'state.next') || '/home');
        }
    }

    updateState = variableName => {
        this.setState(variableName);
    };

    onLogin = async () => {
        this.setState({ formErrors: { password: '' } });

        const { history } = this.props;
        this.setState({ busy: true });
        const success = await session.login(
            this.model.username,
            this.model.password
        );
        this.setState({ busy: false });
        if (success) {
            history.replace('/home');
        } else {
            this.setState({
                formErrors: {
                    password: 'Invalid login',
                    username: 'Invalid login'
                }
            });
        }
    };

    onUserKeyPress = ({ key }) => {
        if (key === 'Enter') {
            this._password.focus();
        }
    };

    onPasswordKeyPress = ({ key }) => {
        if (!this.state.busy && key === 'Enter') {
            this.onLogin();
        }
    };

    render() {
        const model = this.model;

        return (
            <Box>
                <BoxTemplate minheight="200px" />
                <BoxTemplate textalign="center">
                    <img
                        src={require('../assets/Barix_Logo.png')}
                        alt="Barix_logo"
                        width="300"
                    />
                    <Header2>Instreamer ICE</Header2>
                    <BoxTemplate height="15px" />
                    <Box m="auto" w="300px">
                        <Input
                            login="true"
                            placeholder="User"
                            model={model}
                            name="username"
                            onKeyPress={this.onUserKeyPress}
                            disabled={this.state.busy}
                            statevariable={this.state}
                            updateState={this.updateState}
                            white
                            background={Background}
                            errormask={this.state.formErrors.username}
                        />
                        <BoxTemplate height="5px" />
                        <Input
                            login="true"
                            placeholder="Password"
                            type="password"
                            model={model}
                            name="password"
                            innerRef={ref => (this._password = ref)}
                            onKeyPress={this.onPasswordKeyPress}
                            disabled={this.state.busy}
                            statevariable={this.state}
                            updateState={this.updateState}
                            white
                            background={Background}
                            errormask={this.state.formErrors.password}
                            loggin="true"
                        />
                        <BoxTemplate height="15px" />
                        <Button
                            style={{ width: '100%' }}
                            type="submit"
                            busy={this.state.busy}
                            onClick={this.onLogin}
                        >
                            Login
                        </Button>
                        <Box>
                            <p>
                                This web UI works best with the following
                                browsers: Google Chrome, Mozilla Firefox
                            </p>
                        </Box>
                    </Box>
                </BoxTemplate>
            </Box>
        );
    }
}

export default flowRight([withRouter, inject('session'), observer])(Login);



// WEBPACK FOOTER //
// ./src/pages/Login.js